import React, { useMemo, useState } from 'react';
import { Box, Typography, Button, Stack, Dialog } from '@mui/material';
import PageSeo, { breadcrumbJsonLd, keywordSets } from './PageSeo';

import img0006 from './Gallery/IMG-20250514-WA0006.webp';
import img0007 from './Gallery/IMG-20250514-WA0007.webp';
import img0008 from './Gallery/IMG-20250514-WA0008.webp';
import img0009 from './Gallery/IMG-20250514-WA0009.webp';
import img0010 from './Gallery/IMG-20250514-WA0010.webp';
import img0011 from './Gallery/IMG-20250514-WA0011.webp';
import img0012 from './Gallery/IMG-20250514-WA0012.webp';
import img0013 from './Gallery/IMG-20250514-WA0013.webp';
import img0014 from './Gallery/IMG-20250514-WA0014.webp';
import img0015 from './Gallery/IMG-20250514-WA0015.webp';
import img0016 from './Gallery/IMG-20250514-WA0016.webp';
import img0017 from './Gallery/IMG-20250514-WA0017.webp';
import img0018 from './Gallery/IMG-20250514-WA0018.webp';
import img0019 from './Gallery/IMG-20250514-WA0019.webp';
import img0020 from './Gallery/IMG-20250514-WA0020.webp';
import img0021 from './Gallery/IMG-20250514-WA0021.webp';
import img0022 from './Gallery/IMG-20250514-WA0022.webp';
import img0023 from './Gallery/IMG-20250514-WA0023.webp';
import img0024 from './Gallery/IMG-20250514-WA0024.webp';
import img0025 from './Gallery/IMG-20250514-WA0025.webp';
import img0026 from './Gallery/IMG-20250514-WA0026.webp';
import img0027 from './Gallery/IMG-20250514-WA0027.webp';
import img0028 from './Gallery/IMG-20250514-WA0028.webp';
import img0029 from './Gallery/IMG-20250514-WA0029.webp';
import img0030 from './Gallery/IMG-20250514-WA0030.webp';
import img0031 from './Gallery/IMG-20250514-WA0031.webp';
import img0032 from './Gallery/IMG-20250514-WA0032.webp';
import img0033 from './Gallery/IMG-20250514-WA0033.webp';
import img0034 from './Gallery/01.webp';
import img0035 from './Gallery/02.webp';
import img0036 from './Gallery/03.webp';
import img0037 from './Gallery/04.webp';
import img0038 from './Gallery/05.webp';
import img0039 from './Gallery/06.webp';
import img0040 from './Gallery/07.webp';
import img0041 from './Gallery/08.webp';
import img0042 from './Gallery/09.webp';
import img0043 from './Gallery/10.webp';
import img0044 from './Gallery/11.webp';
import img0045 from './Gallery/12.webp';
import img0046 from './Gallery/13.webp';
import img0047 from './Gallery/14.webp';
import jun01 from './Gallery/jun1.webp';
import jun02 from './Gallery/jun2.webp';
import jun03 from './Gallery/jun3.webp';
import jun04 from './Gallery/jun4.webp';
import jun05 from './Gallery/jun5.webp';
import jun06 from './Gallery/jun6.webp';
import jun07 from './Gallery/jun7.webp';
import jun08 from './Gallery/jun8.webp';
import jun09 from './Gallery/jun9.webp';
import jun10 from './Gallery/jun10.webp';
import jun11 from './Gallery/jun11.webp';
import jun12 from './Gallery/jun12.webp';
import jun13 from './Gallery/jun13.webp';
import jun14 from './Gallery/jun14.webp';
import jun15 from './Gallery/jun15.webp';
import jun16 from './Gallery/jun16.webp';
import jun17 from './Gallery/jun17.webp';
import jun18 from './Gallery/jun18.webp';
import jun19 from './Gallery/jun19.webp';
import jun20 from './Gallery/jun20.webp';
import jun21 from './Gallery/jun21.webp';
import jun22 from './Gallery/jun22.webp';
import jun23 from './Gallery/jun23.webp';

import serahterima1 from './images/serahterima/1.webp';
import serahterima2 from './images/serahterima/2.webp';
import serahterima3 from './images/serahterima/3.webp';
import serahterima4 from './images/serahterima/4.webp';
import serahterima5 from './images/serahterima/5.webp';
import serahterima6 from './images/serahterima/6.webp';
import serahterima7 from './images/serahterima/7.webp';
import serahterima8 from './images/serahterima/8.webp';
import serahterima9 from './images/serahterima/9.webp';
import serahterima10 from './images/serahterima/10.webp';
import serahterima11 from './images/serahterima/11.webp';
import serahterima12 from './images/serahterima/12.webp';
import serahterima13 from './images/serahterima/13.webp';
import serahterima14 from './images/serahterima/14.webp';
import serahterima15 from './images/serahterima/15.webp';
import serahterima16 from './images/serahterima/16.webp';
import serahterima17 from './images/serahterima/17.webp';
import serahterima18 from './images/serahterima/18.webp';
import serahterima19 from './images/serahterima/19.webp';
import serahterima20 from './images/serahterima/20.webp';
import serahterima21 from './images/serahterima/21.webp';
import serahterima22 from './images/serahterima/22.webp';
import serahterima23 from './images/serahterima/23.webp';
import serahterima24 from './images/serahterima/24.webp';
import serahterima25 from './images/serahterima/25.webp';
import serahterima26 from './images/serahterima/26.webp';
import serahterima27 from './images/serahterima/27.webp';
import serahterima28 from './images/serahterima/28.webp';
import serahterima29 from './images/serahterima/29.webp';
import serahterima30 from './images/serahterima/30.webp';
import serahterima31 from './images/serahterima/31.webp';
import serahterima32 from './images/serahterima/32.webp';
import serahterima33 from './images/serahterima/33.webp';
import serahterima34 from './images/serahterima/34.webp';
import serahterima35 from './images/serahterima/35.webp';
import serahterima36 from './images/serahterima/36.webp';

// Semua foto di folder serah-terima-2 otomatis masuk gallery.
// Cukup taruh file baru (.jpg/.jpeg/.png/.webp) di folder itu; urutan
// mengikuti nama file, yang terbaru ditampilkan lebih dulu.
const serahTerima2Context = require.context(
  './images/serah-terima-2',
  false,
  /\.(jpe?g|png|webp)$/i,
);
const serahTerima2Images = serahTerima2Context
  .keys()
  .sort()
  .reverse()
  .map((key) => {
    const asset = serahTerima2Context(key);
    return asset && asset.default ? asset.default : asset;
  });

const serahTerimaImages = [
  ...serahTerima2Images,
  serahterima26,
  serahterima27,
  serahterima28,
  serahterima29,
  serahterima30,
  serahterima31,
  serahterima32,
  serahterima33,
  serahterima34,
  serahterima35,
  serahterima36,
  serahterima1,
  serahterima2,
  serahterima3,
  serahterima4,
  serahterima5,
  serahterima6,
  serahterima7,
  serahterima8,
  serahterima9,
  serahterima10,
  serahterima11,
  serahterima12,
  serahterima13,
  serahterima14,
  serahterima15,
  serahterima16,
  serahterima17,
  serahterima18,
  serahterima19,
  serahterima20,
  serahterima21,
  serahterima22,
  serahterima23,
  serahterima24,
  serahterima25,
];

const otherImages = [
  jun01,
  jun02,
  jun03,
  jun04,
  jun05,
  jun06,
  jun07,
  jun08,
  jun09,
  jun10,
  jun11,
  jun12,
  jun13,
  jun14,
  jun15,
  jun16,
  jun17,
  jun18,
  jun19,
  jun20,
  jun21,
  jun22,
  jun23,
  img0034,
  img0035,
  img0036,
  img0037,
  img0038,
  img0039,
  img0040,
  img0041,
  img0042,
  img0043,
  img0044,
  img0045,
  img0046,
  img0047,
  img0006,
  img0007,
  img0008,
  img0009,
  img0010,
  img0011,
  img0012,
  img0013,
  img0014,
  img0015,
  img0016,
  img0017,
  img0018,
  img0019,
  img0020,
  img0021,
  img0022,
  img0023,
  img0024,
  img0025,
  img0026,
  img0027,
  img0028,
  img0029,
  img0030,
  img0031,
  img0032,
  img0033,
];

function Gallery() {
  const initialCount = 16;
  const loadCount = 12;
  const [visibleCount, setVisibleCount] = useState(initialCount);
  const [selectedIndex, setSelectedIndex] = useState(null);

  const galleryImages = useMemo(
    () => [...serahTerimaImages, ...otherImages],
    [],
  );
  const featuredImages = galleryImages.slice(0, 3);

  const visibleImages = galleryImages.slice(0, visibleCount);
  const hasMore = visibleCount < galleryImages.length;

  const selectedImage =
    selectedIndex !== null ? galleryImages[selectedIndex] : undefined;

  const handleShowMore = () => {
    setVisibleCount((prev) => Math.min(prev + loadCount, galleryImages.length));
  };

  const handlePreviousImage = () => {
    setSelectedIndex((prev) =>
      prev === null
        ? 0
        : (prev - 1 + galleryImages.length) % galleryImages.length,
    );
  };

  const handleNextImage = () => {
    setSelectedIndex((prev) =>
      prev === null ? 0 : (prev + 1) % galleryImages.length,
    );
  };

  return (
    <Box
      component='main'
      sx={{
        backgroundColor: '#f5f7fa',
        minHeight: '100vh',
        px: { xs: 2, sm: 4, md: 6 },
        pt: { xs: 12, sm: 14 },
        pb: { xs: 6, sm: 9 },
        scrollMarginTop: { xs: '80px', sm: '90px', md: '100px' },
      }}
    >
      <PageSeo
        title='Gallery Serah Terima BYD BSD Serpong | Foto Konsumen Junius'
        description='Lihat gallery serah terima unit BYD BSD Serpong bersama Junius, termasuk BYD Atto 1, M6, Sealion 7, Danza D9, Dolphin, dan Seal.'
        keywords={[
          ...keywordSets.localDealer,
          'gallery BYD BSD Serpong',
          'serah terima BYD BSD',
          'foto konsumen BYD',
        ]}
        path='/gallery'
        image={serahterima1}
        jsonLd={breadcrumbJsonLd([
          { name: 'Beranda', path: '/' },
          { name: 'Gallery Serah Terima', path: '/gallery' },
        ])}
      />

      <Box sx={{ maxWidth: 1320, mx: 'auto' }}>
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: { xs: '1fr', lg: '0.9fr 1.1fr' },
            gap: { xs: 3, md: 4 },
            alignItems: 'end',
            mb: { xs: 4, md: 5 },
          }}
        >
          <Box>
            <Typography
              sx={{
                color: '#2d6cdf',
                fontWeight: 900,
                letterSpacing: 0.4,
                textTransform: 'uppercase',
                fontSize: '0.82rem',
              }}
            >
              Gallery BYD BSD Serpong
            </Typography>
            <Typography
              variant='h1'
              component='h1'
              sx={{
                mt: 1,
                fontWeight: 900,
                lineHeight: 1,
                color: '#111827',
                fontSize: { xs: '2.3rem', sm: '3.2rem', md: '4rem' },
              }}
            >
              Serah Terima Unit
            </Typography>
          </Box>

          <Box>
            <Typography
              sx={{
                color: '#4b5563',
                lineHeight: 1.75,
                fontSize: { xs: '1rem', md: '1.05rem' },
              }}
            >
              Dokumentasi penyerahan unit kepada pelanggan BYD BSD Serpong
              bersama Junius.
            </Typography>

            <Box
              sx={{
                mt: 2,
                display: 'flex',
                gap: 1,
                flexWrap: 'wrap',
              }}
            >
              <Box
                sx={{
                  px: 2,
                  py: 1,
                  borderRadius: '8px',
                  backgroundColor: '#fff',
                  border: '1px solid rgba(45,108,223,0.24)',
                  color: '#1f2937',
                  fontWeight: 800,
                }}
              >
                {galleryImages.length} foto serah terima
              </Box>
            </Box>
          </Box>
        </Box>

        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: { xs: '1fr', md: '1.35fr 0.65fr' },
            gridTemplateRows: { xs: 'auto', md: '1fr 1fr' },
            gap: 2,
            mb: { xs: 4, md: 5 },
          }}
        >
          {featuredImages.map((image, index) => (
            <Box
              component='button'
              type='button'
              key={image}
              onClick={() => setSelectedIndex(index)}
              sx={{
                all: 'unset',
                display: 'block',
                width: '100%',
                height: '100%',
                minHeight: index === 0 ? { xs: 260, md: 520 } : 250,
                position: 'relative',
                overflow: 'hidden',
                borderRadius: '8px',
                cursor: 'pointer',
                gridRow: index === 0 ? { md: '1 / span 2' } : 'auto',
                boxShadow: '0 16px 32px rgba(16,24,40,0.12)',
                backgroundColor: '#d7dde6',
                '&:hover img': { transform: 'scale(1.05)' },
              }}
            >
              <Box
                component='img'
                src={image}
                alt={`Gallery ${index + 1}`}
                loading='lazy'
                sx={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                  display: 'block',
                  transition: 'transform 0.35s ease',
                }}
              />
              <Box
                sx={{
                  position: 'absolute',
                  inset: 0,
                  background:
                    'linear-gradient(180deg, rgba(0,0,0,0.02) 0%, rgba(0,0,0,0.46) 100%)',
                }}
              />
              <Typography
                sx={{
                  position: 'absolute',
                  left: 16,
                  bottom: 14,
                  color: '#fff',
                  fontWeight: 900,
                  textShadow: '0 4px 12px rgba(0,0,0,0.35)',
                }}
              >
                {index === 0 ? 'Momen Terbaru' : `Pilihan Foto ${index + 1}`}
              </Typography>
            </Box>
          ))}
        </Box>

        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: {
              xs: 'repeat(2, minmax(0, 1fr))',
              sm: 'repeat(3, minmax(0, 1fr))',
              md: 'repeat(4, minmax(0, 1fr))',
            },
            gridAutoRows: { xs: 145, sm: 180, md: 210 },
            gap: { xs: 1.5, md: 2 },
          }}
        >
          {visibleImages.map((image, index) => {
            const isLarge = index % 13 === 0;
            const isTall = index % 9 === 4;

            return (
              <Box
                component='button'
                type='button'
                key={`handover-${index}`}
                onClick={() => setSelectedIndex(index)}
                sx={{
                  all: 'unset',
                  display: 'block',
                  position: 'relative',
                  overflow: 'hidden',
                  borderRadius: '8px',
                  backgroundColor: '#e4e8ef',
                  cursor: 'pointer',
                  boxShadow: '0 8px 20px rgba(16,24,40,0.08)',
                  gridColumn: {
                    xs: 'span 1',
                    sm: isLarge ? 'span 2' : 'span 1',
                  },
                  gridRow: {
                    xs: 'span 1',
                    sm: isLarge || isTall ? 'span 2' : 'span 1',
                  },
                  '&:hover img': { transform: 'scale(1.06)' },
                  '&:focus-visible': {
                    outline: '3px solid #2d6cdf',
                    outlineOffset: 3,
                  },
                }}
              >
                <Box
                  component='img'
                  src={image}
                  alt={`Serah Terima Unit ${index + 1}`}
                  loading='lazy'
                  sx={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                    display: 'block',
                    transition: 'transform 0.35s ease',
                  }}
                />
              </Box>
            );
          })}
        </Box>

        {hasMore && (
          <Stack alignItems='center' sx={{ mt: 5 }}>
            <Button
              variant='contained'
              onClick={handleShowMore}
              sx={{
                px: 4,
                py: 1.2,
                borderRadius: '8px',
                textTransform: 'none',
                fontWeight: 800,
                backgroundColor: '#2d6cdf',
                '&:hover': { backgroundColor: '#1f5fc8' },
              }}
            >
              Tampilkan Foto Lainnya
            </Button>
            <Typography sx={{ mt: 1.5, color: '#667085', fontSize: '0.9rem' }}>
              {visibleImages.length} dari {galleryImages.length} foto
            </Typography>
          </Stack>
        )}
      </Box>

      <Dialog
        open={Boolean(selectedImage)}
        onClose={() => setSelectedIndex(null)}
        maxWidth={false}
        PaperProps={{
          sx: {
            width: { xs: '94vw', md: '86vw' },
            maxWidth: 1200,
            borderRadius: '8px',
            backgroundColor: '#0b0f16',
            color: '#fff',
            overflow: 'hidden',
          },
        }}
      >
        {selectedImage && (
          <Box>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                gap: 2,
                px: { xs: 1.5, sm: 2 },
                py: 1.5,
                borderBottom: '1px solid rgba(255,255,255,0.12)',
              }}
            >
              <Typography sx={{ fontWeight: 800 }}>
                Serah Terima Unit {selectedIndex + 1} / {galleryImages.length}
              </Typography>
              <Button
                onClick={() => setSelectedIndex(null)}
                sx={{
                  color: '#fff',
                  borderRadius: '8px',
                  textTransform: 'none',
                  fontWeight: 800,
                }}
              >
                Tutup
              </Button>
            </Box>

            <Box
              sx={{
                position: 'relative',
                minHeight: { xs: '62vh', md: '76vh' },
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: '#05070b',
              }}
            >
              <Button
                onClick={handlePreviousImage}
                sx={{
                  position: 'absolute',
                  left: { xs: 8, md: 16 },
                  zIndex: 2,
                  minWidth: 44,
                  width: 44,
                  height: 44,
                  borderRadius: '8px',
                  color: '#fff',
                  backgroundColor: 'rgba(0,0,0,0.48)',
                  '&:hover': { backgroundColor: 'rgba(0,0,0,0.72)' },
                }}
              >
                ‹
              </Button>
              <Box
                component='img'
                src={selectedImage}
                alt={`Serah Terima Unit ${selectedIndex + 1}`}
                sx={{
                  width: '100%',
                  maxHeight: { xs: '72vh', md: '82vh' },
                  objectFit: 'contain',
                  display: 'block',
                }}
              />
              <Button
                onClick={handleNextImage}
                sx={{
                  position: 'absolute',
                  right: { xs: 8, md: 16 },
                  zIndex: 2,
                  minWidth: 44,
                  width: 44,
                  height: 44,
                  borderRadius: '8px',
                  color: '#fff',
                  backgroundColor: 'rgba(0,0,0,0.48)',
                  '&:hover': { backgroundColor: 'rgba(0,0,0,0.72)' },
                }}
              >
                ›
              </Button>
            </Box>
          </Box>
        )}
      </Dialog>
    </Box>
  );
}

export default Gallery;
